import { useRef } from 'react'
import { NormalizedApproval, SubTab } from '@opallabs/wormhole/types'
import { Runnable } from '../types'
import { BucketedApprovals } from './types'

interface CheckpointCreators {
  createCompletedCheckpoint: Runnable
  createOverdueCheckpoint: Runnable
  createPendingCheckpoint: Runnable
}

interface UseCheckpointArg {
  approvals: BucketedApprovals
  completedApprovalsLoading: boolean
  createCheckpoint: (subTab: SubTab, approvals: NormalizedApproval[]) => void
  overdueApprovalsLoading: boolean
  pendingApprovalsLoading: boolean
}

type UseCheckpointCreators = (arg: UseCheckpointArg) => CheckpointCreators

export const useCheckpointCreators: UseCheckpointCreators = ({
  approvals,
  completedApprovalsLoading,
  createCheckpoint,
  overdueApprovalsLoading,
  pendingApprovalsLoading,
}) => {
  const pendingCheckpointCreated = useRef(false)
  const overdueCheckpointCreated = useRef(false)
  const completedCheckpointCreated = useRef(false)

  const createPendingCheckpoint: Runnable = () => {
    if (
      approvals.pending.length > 0 &&
      !pendingCheckpointCreated.current &&
      !pendingApprovalsLoading
    ) {
      pendingCheckpointCreated.current = true
      createCheckpoint('Pending', approvals.pending)
    }
  }

  const createOverdueCheckpoint: Runnable = () => {
    if (
      approvals.overdue.length > 0 &&
      !overdueCheckpointCreated.current &&
      !overdueApprovalsLoading
    ) {
      overdueCheckpointCreated.current = true
      createCheckpoint('Overdue', approvals.overdue)
    }
  }

  const createCompletedCheckpoint: Runnable = () => {
    if (
      approvals.completed.length > 0 &&
      !completedCheckpointCreated.current &&
      !completedApprovalsLoading
    ) {
      completedCheckpointCreated.current = true
      createCheckpoint('Completed', approvals.completed)
    }
  }

  return {
    createCompletedCheckpoint,
    createOverdueCheckpoint,
    createPendingCheckpoint,
  }
}
